const months: string[] = [];

for (let i = 1; i <= 12; i++) {
  months.push(`${i}월`);
}

export default months;

// personnel
export const careerLabels = ['0~5년차', '6~10년차', '11~15년차', '16~20년차', '20년차 이상'];
export const ageLabels = ['10대', '20대', '30대', '40대', '50대', '60대 이상'];
export const genderLabels = ['남성', '여성'];
export const elementLabels = ['1학년', '2학년', '3학년', '4학년', '5학년', '6학년'];
export const middleLabels = ['1학년', '2학년', '3학년'];

export const chartType = ['career', 'age', 'gender'];
export const careerType = ['five', 'ten', 'fifteen', 'twenty', 'gttwenty'];
export const ageType = ['teenager', 'twenty', 'thirty', 'forty', 'fifty', 'sixty'];
export const genderType = ['male', 'female'];

// posture
export const postureLabels = ['심각', '중증도', '경미', '정상', '경미', '중증도', '심각'];

// rom
export const romLabels = ['정상', '주의'];
export const romColumnTitles = ['부위', '지표', '구분', '상세구분', '비율(%)', '인원수(명)'];
export const romRowTitles = [
  '목굴곡',
  '목신전',
  '목측굴',
  '몸통측굴',
  '허리굴곡',
  '허리신전',
  '어꺠외전',
  '어깨굴곡',
  '어깨신전',
  '어깨내회전',
  '어깨외회전',
  '팔꿈치굴곡',
  '팔꿈치신전',
  '무릎굴곡OKC',
  '무릎신전OKC',
  '고관절외전',
  '고관절굴곡',
  '고관절신전',
  '고관절내회전',
  '고관절외회전'
];
